import httpService from '@/utils/request'
import { contextPath } from '@/config/'


export const getServiceNodeListApi = (params) => {
  return httpService({
    url: contextPath + '/system/server/info',
    method: 'get',
    params
  })
}